import {languageService} from "./language/language.service";
import {LocaleService} from "./language/Locale";
import {ContractService} from "./Contract";
import {credentialsFactory} from "./credentials/credentialsService";
import {valueFactory} from "./Value";
import {cfnHttpInterceptorFactory} from "./system/cfnHttpInterceptor";
import {CountryService} from "./country/countryService";
import {systemConfigConstant} from "./system/system-config.constant";
import {fnComponentsModuleName} from "@farmnet/components/dist/farmnet-components";
import {translateFilter} from "./language/translateFilter";
import {alertController} from "./alert/alertController";
import {windowController} from "./window/windowController";
import {UserSessionStorageService} from "./storage/userSessionStorage.service";
import {LocalStorageService} from "./storage/localStorage.service";
import {SessionStorageService} from "./storage/sessionStorage.service";
import {baseRun} from "./farmnet.base.run";
import {baseConfig} from "./farmnet.base.config";
import {cfnInputZipReg} from "./directives/text-and-numbers.directives";
import {demoAccountServiceProvider} from "./system/demoAccountServiceProvider";
import '@farmnet/feature-toggle/dist/farmnet-featuretoggle.js';


export const farmnetBaseModule = 'farmnet.base';

const module = angular.module(farmnetBaseModule, [
  'farmnet.base.tracking',
  'farmnet.featuretoggle',
  fnComponentsModuleName,
  'tmh.dynamicLocale',
  'ngSanitize',
  'ui.bootstrap',
]);

module.run(baseRun);
module.config(baseConfig);
module.constant('farmnetConfig', {
  version: '2.12.14',
  modulesBasePath: 'app/modules',
  restBasePath: '/365FarmNet/rest'
});

module.factory('credentials', credentialsFactory);
module.factory('value', valueFactory);
module.factory('CfnHttpInterceptor', cfnHttpInterceptorFactory);
module.factory('CountryService', CountryService);
module.provider('languageService', languageService);
module.service('Locale', LocaleService);
module.service('Contract', ContractService);
module.constant('system-config.constant', systemConfigConstant);
module.filter('i18n', translateFilter);
module.filter('translate', translateFilter);
module.controller('AlertController', alertController);
module.controller('windowController', windowController);
module.factory('UserSessionStorageService', UserSessionStorageService);
module.factory('LocalStorageService', LocalStorageService);
module.factory('SessionStorageService', SessionStorageService);
module.directive('cfnInputZipReg', cfnInputZipReg);
module.provider('DemoAccountService', demoAccountServiceProvider);

